import { useQuery, useMutation, useQueryClient } from "react-query";
import { getPendingApproval, saveApproval } from "@/api/Products/PendingApproval/pending-approval-query";

const key = "pending-approval";

export function usePendingApproval(params) {
	return useQuery([key], () => getPendingApproval(params), {});
}

export function useSaveApproval(params) {
	const queryClient = useQueryClient();

	return useMutation(saveApproval, {
		onSuccess: (_response) => {
			queryClient.invalidateQueries([key, params]);
		},
	});
}
